import { useEffect } from "react";
import { AlertTriangle, Loader2, RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const EmbedStatus = () => {
  const { embedError, startEmbedded } = useAuth();

  useEffect(() => {
    startEmbedded();
  }, [startEmbedded]);

  if (!embedError) {
    return (
      <div
        className="flex min-h-screen items-center justify-center gap-2 bg-slate-100 font-admin text-sm text-slate-600"
        role="status"
        aria-live="polite"
        data-testid="embed-waiting-screen"
      >
        <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Connexion au portail Moovapps…
      </div>
    );
  }

  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-slate-100 p-6 text-center font-admin"
      data-testid="embed-error-screen"
    >
      <div role="alert" className="flex max-w-md flex-col items-center gap-2">
        <AlertTriangle className="h-6 w-6 text-amber-600" aria-hidden="true" />
        <p className="font-medium text-slate-900">Impossible d'ouvrir la console RGPD</p>
        <p className="text-sm text-slate-600" data-testid="embed-error-message">{embedError}</p>
      </div>
      <Button variant="outline" onClick={startEmbedded} data-testid="embed-retry-button">
        <RotateCw className="mr-2 h-4 w-4" aria-hidden="true" /> Réessayer
      </Button>
    </div>
  );
};
